<section class="image-ticker">
  <h2>{{ title }}</h2>
  <div class="ticker-view">
    <div class="ticker-bar">
      <div
        class="block"
        *ngFor="let block of blocks"
        [ngStyle]="{
          left: (block.position - 1) * (100 / 6) + '%',
          opacity: block.position >= 6 || block.position < 2 ? 0 : 1
        }"
      >
        <img
          src="{{ block.image }}"
          alt="{{ block.content }}"
          class="ticker-image"
        />
      </div>
    </div>
  </div>
</section>
